module.exports = __webpack_public_path__ + "assets/images/1dcd043ac8f91968649694a8bd32de14.svg";